import styled from 'styled-components';

export const MultiFlightMapStyled = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
`;

export const MultiFlightMapContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
